<template>
  <div>
    <Alert
      class="my-8 kft-alert--info"
      :content="$t('product.preview.alert.content')"
      :title="$t('product.preview.alert.title')"
    />
    <EventDetails
      :is-preview="true"
      :should-add-event-schema="true"
      :event-permalink="$route.params.previewPermalink.toString()"
      :is-giftcard="false"
    ></EventDetails>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  // name: 'event-details-page', // explicit naming requires more attention with localization
  layout: 'default-max-screen',
  allowOnPartnerPage: true,
  contentGroup: 'other',
})
</script>
